import { a as l } from "../../../vee-validate.esm-c4518011.js";
import { defineComponent as d, computed as p, openBlock as r, createElementBlock as a, normalizeClass as c, createElementVNode as s, renderSlot as m, toDisplayString as u, createCommentVNode as f } from "vue";
import { useSpacingClass as g } from "../../../composables/useSpacingClass.js";
import { _ as h } from "../../../_plugin-vue_export-helper-dad06003.js";
const v = d({
  name: "VFormRadioCheckboxGroup",
  inheritAttrs: !1,
  props: {
    fieldName: {
      type: String,
      default: ""
    },
    bottomSpacing: {
      type: String,
      default: "m"
    },
    topSpacing: {
      type: String,
      default: "m"
    }
  },
  setup(e) {
    const { errorMessage: t } = l(e.fieldName, [], {
      validateOnMount: !1,
      uncheckedValue: "",
      initialValue: ""
    }), { topAndBottomSpacing: o } = g(e);
    return {
      isInvalid: p(() => !!t && t.value !== void 0),
      errorMessage: t,
      wrapperClass: o
    };
  }
}), C = { class: "tw-flex" }, S = ["id"];
function w(e, t, o, i, n, _) {
  return r(), a("div", {
    class: c(["hobi-form-radio-checkbox-group tw-flex tw-flex-col", e.wrapperClass])
  }, [
    s("div", C, [
      m(e.$slots, "default")
    ]),
    s("div", null, [
      e.isInvalid ? (r(), a("p", {
        key: 0,
        id: `hobi-${e.fieldName}-error-message`,
        class: "tw-mt-2 tw-text-red"
      }, u(e.errorMessage), 9, S)) : f("", !0)
    ])
  ], 2);
}
const x = /* @__PURE__ */ h(v, [["render", w]]);
export {
  x as default
};
